module.exports = __webpack_public_path__ + "assets/img/sc20.88517034.jpg";